import * as actions from './actionTypes.js';

export const setBreadcrumbRedux = (breadcrumb) => {
    return {
        type: actions.ADD_TO_BREAD_CRUMBS,
        payload: breadcrumb,
    };
}
